import moment from "moment"
import React from "react"
import { Navigate } from "react-router-dom"
import Curriculum from "../../opening_module/pages/curriculum"
import Lessons from "../../opening_module/pages/lessons"
import Navigation from "../navigation"
import { ReportNavigation } from "../navigation/report_navigation"
import Report from "../report"
import Schedule from "../schedule"
import NewSchedulePage from "../schedule/new"
import { StudentsView } from "../students"
import { Tutors } from "../tutors"

const root = "/"

const routes = [
  {
    routeName: "",
    routeTitleName: "Schedule",
    routesPatterns: "/:scheduleId",
  },
  {
    routeName: "students",
    routeTitleName: "Students",
    routesPatterns: "/:scheduleId/students",
  },
  {
    routeName: "tutors",
    routeTitleName: "Tutors",
    routesPatterns: "/:scheduleId/tutors",
  },
  {
    routeName: "reports",
    routeTitleName: "Reports",
    routesPatterns: "/:scheduleId/reports/:report_date",
  },
  {
    routeName: "sessions",
    routeTitleName: "Sessions",
    routesPatterns: "/:scheduleId/sessions",
  },
  {
    routeName: "curriculum",
    routeTitleName: "Curriculum",
    routesPatterns: "/:scheduleId/curriculum",
    featureFlagName: "curriculum_enabled",
  },
]

export const RouteNames = Object.freeze({
  Schedules: "",
  Students: "students",
  Tutors: "tutors",
  Reports: "reports",
  Sessions: "sessions",
  Curriculum: "curriculum"
})

export const RoutesTitleNames = Object.freeze({
  [RouteNames.Schedules]: "Schedule",
  [RouteNames.Reports]: "Report",
  [RouteNames.Students]: "Students",
  [RouteNames.Tutors]: "Tutors",
  [RouteNames.Sessions]: "Sessions",
  [RouteNames.Curriculum]: "Curriculum",
})

export const RoutesPatterns = Object.freeze({
  [RouteNames.Schedules]: "/:scheduleId",
  [RouteNames.Reports]: `/:scheduleId/${RouteNames.Reports}/:report_date`,
  [RouteNames.Tutors]: `/:scheduleId/${RouteNames.Tutors}`,
  [RouteNames.Students]: `/:scheduleId/${RouteNames.Students}`,
  [RouteNames.Sessions]: `/:scheduleId/${RouteNames.Sessions}`,
  [RouteNames.Curriculum]: `/:scheduleId/${RouteNames.Curriculum}`,
})

const currentDate = moment().startOf(new Date()).format("YYYY-MM-DD")

const showBasedOnFeatureFlag = (featureFlags, navigationItems, _, isCurriculumProgram) => {
  if (!featureFlags) return navigationItems

  return navigationItems.filter(nav => {
    if (!nav.featureFlagName) return true
    // TODO we need to find a better way to handle the visibility of navigation
    if (
      nav.featureFlagName === "curriculum_enabled" &&
      !isCurriculumProgram
    ) {
      return false
    }
     

    return !!featureFlags[nav.featureFlagName]
  })
}

const scheduleNavigationItems = [
  {
    path: RouteNames.Schedules,
    element: <Schedule />,
  },
  {
    path: RouteNames.Students,
    element: <StudentsView />,
  },
  {
    path: RouteNames.Reports,
    element: <ReportNavigation />,
    children: [
      {
        path: "",
        element: <Navigate to={currentDate} />,
      },
      {
        path: ":report_date",
        element: <Report />,
      },
      {
        path: "*",
        element: <Navigate to={currentDate} />,
      },
    ],
  },
  {
    path: RouteNames.Tutors,
    element: <Tutors />,
  },
  {
    path: RouteNames.Sessions,
    element: <Lessons />,
  },
  {
    path: RouteNames.Curriculum,
    element: <Curriculum />,
    featureFlagName: "curriculum_enabled",
  },
]

export const getNavigationConfig = initial => [
  {
    path: root,
    element: <Navigation initial={initial} />,
    children: [
      {
        path: ":scheduleId",
        children: showBasedOnFeatureFlag(initial?.currentUser?.feature_flags, scheduleNavigationItems, initial?.currentUser, true),
      },
    ],
  },
  {
    path: "new",
    element: <NewSchedulePage />,
  },
]

export const tabsNavigationConfig = (currentUser, isCurriculumProgram) =>
  showBasedOnFeatureFlag(currentUser?.feature_flags, routes, currentUser, isCurriculumProgram).map(route => ({
    route,
    pattern: route.routesPatterns,
    title: route.routeTitleName,
  }))
